import { Link } from 'react-router-dom';
import Avatar from './Avatar';
import './Card.css';

export function MentorCard({ mentor, onContact }) {
  const user = mentor.user || {};
  const ais  = mentor.alumni_impact_score;
  return (
    <Link to={`/mentors/${mentor.id}`} className="card mentor-card card--link">
      <Avatar user={user} size="md" className="card-avatar" />
      <div className="card-body">
        <h3 className="card-name">{user.full_name}</h3>
        <p className="card-sub">{mentor.title} · {mentor.company}</p>
        <p className="card-location">{mentor.location}</p>
        <div className="card-tags">
          {(mentor.domains || []).slice(0, 3).map((d) => (
            <span key={d} className="tag">{d}</span>
          ))}
        </div>
        <div className="card-meta">
          {ais > 0 ? (
            <span className="ais-badge ais-badge--active" title="Alumni Impact Score™ v1 — score de contribution calculé (0–1000)">
              AIS™ <strong>{ais}</strong><span className="ais-denom">/1000</span>
            </span>
          ) : (
            <span className="ais-badge ais-badge--empty" title="Alumni Impact Score™ v1 — en construction">
              AIS™ —
            </span>
          )}
          <span>⭐ {mentor.rating?.toFixed(1) || '–'}</span>
          <span>{mentor.session_count || 0} sessions</span>
          {mentor.is_verified && <span className="badge verified">Vérifié</span>}
        </div>
      </div>
      {onContact && (
        <button
          className="card-btn"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); onContact(mentor); }}
        >Contacter</button>
      )}
    </Link>
  );
}

export function MasterclassCard({ item, onEnroll }) {
  const isFree = item.type === 'gratuit' || item.price === 0;
  return (
    <div className="card">
      <div className="card-header-img">
        <span className="category-badge">{item.category}</span>
        <span className={`type-badge ${item.type}`}>{isFree ? 'Gratuit' : 'Payant'}</span>
      </div>
      <div className="card-body">
        <h3 className="card-name">{item.title}</h3>
        <p className="card-sub">{item.mentor?.user?.full_name}</p>
        <p className="card-desc">{item.description?.slice(0, 100)}...</p>
        <div className="card-meta">
          <span>⭐ {item.rating?.toFixed(1) || '–'}</span>
          <span>{item.enrolled_count || 0} inscrits</span>
          <span>{item.duration_hours}h</span>
        </div>
      </div>
      {onEnroll && (
        <button className="card-btn" onClick={() => onEnroll(item)}>
          {isFree ? "S'inscrire gratuitement" : `S'inscrire · ${item.price?.toLocaleString()} DZD`}
        </button>
      )}
    </div>
  );
}

export function OpportunityCard({ item, onApply }) {
  const isExpired = item.deadline && new Date(item.deadline) < new Date();
  return (
    <div className={`card opp-card ${isExpired ? 'expired' : ''}`}>
      <div className="card-body">
        <div className="opp-header">
          <h3 className="card-name">{item.title}</h3>
          {item.is_urgent && <span className="badge urgent">Urgent</span>}
        </div>
        <p className="card-sub">{item.company} · {item.location}</p>
        <span className={`tag type-${item.type}`}>{item.type}</span>
        <p className="card-desc">{item.description?.slice(0, 120)}...</p>
        <div className="card-meta">
          {item.deadline && (
            <span className={isExpired ? 'expired-text' : ''}>
              {isExpired ? 'Expiré' : `Clôture : ${new Date(item.deadline).toLocaleDateString('fr-DZ')}`}
            </span>
          )}
          <span>{item.application_count || 0} candidatures</span>
        </div>
      </div>
      {onApply && !isExpired && (
        <button className="card-btn" onClick={() => onApply(item)}>Postuler</button>
      )}
    </div>
  );
}
